// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 2V4H9V2H11V4H13V2H15V4H17V2H19V14H21V13H23V22H15.5V14H8.5V22H1V13H3V14H5V2H7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.5 22V16H10.5V22H13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-castle-filled')
export default class CastleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-filled',
    }
  }
}
